import { RackOptions } from "../../../RackTypes"
import { determineTrainerVariant } from "../../../utils/fxt-utils"
import { createStandardConfig } from "./config/variants/standard/createStandardConfig"
import { createStandardAddonConfig } from "./config/variants/standard/createStandardAddonConfig"
import { createHRConfig } from "./config/variants/hr/createHRConfig"
import { createHRAddonConfig } from "./config/variants/hr/createHRAddonConfig"
import { createRhinoConfig } from "./config/variants/rhino/createRhinoConfig"
import { createRhinoAddonConfig } from "./config/variants/rhino/createRhinoAddonConfig"
import { createTwinConfig } from "./config/variants/twin/createTwinConfig"
import { createTwinAddonConfig } from "./config/variants/twin/createTwinAddonConfig"
import { createTwinHRConfig } from "./config/variants/twin-hr/createTwinHRConfig"
import { createTwinHRAddonConfig } from "./config/variants/twin-hr/createTwinHRAddonConfig"
import { createIndyConfig } from "./config/variants/indy/createIndyConfig"
import { createIndyAddonConfig } from "./config/variants/indy/createIndyAddonConfig"
import { createLatLowRowConfig } from "./config/variants/lat-low-row/createLatLowRowConfig"
import { createLatLowRowAddonConfig } from "./config/variants/lat-low-row/createLatLowRowAddonConfig"
import { createSlingerXConfig } from "./config/variants/slinger-x/createSlingerXConfig"
import { createSlingerXAddonConfig } from "./config/variants/slinger-x/createSlingerXAddonConfig"
import { FunctionalTrainerFactory } from "./functionalTrainerFactory"
import { IRogue, BuyRequest } from "@/js/services/RogueTypes"


function createFunctionalTrainerConfig(rogue: IRogue, buyRequest: BuyRequest): RackOptions {
  const variant = determineTrainerVariant(rogue, buyRequest)
  
  switch (variant) {
    case 'slingerX':
      return createSlingerXConfig(rogue, buyRequest)
    case 'addon-slingerx':
      return createSlingerXAddonConfig(rogue, buyRequest)
    case 'rhino':
      return createRhinoConfig(rogue, buyRequest)
    case 'twin':
      return createTwinConfig(rogue, buyRequest)
    case 'lat-low-row':
      return createLatLowRowConfig(rogue, buyRequest)
    case 'indy':
      return createIndyConfig(rogue, buyRequest)
    case 'hr':
      return createHRConfig(rogue, buyRequest)
    case 'twin-hr':
      return createTwinHRConfig(rogue, buyRequest)
    case 'addon-rhino':
      return createRhinoAddonConfig(rogue, buyRequest)
    case 'addon-twin-hr':
      return createTwinHRAddonConfig(rogue, buyRequest)
    case 'addon-twin':
      return createTwinAddonConfig(rogue, buyRequest)
    case 'addon-hr':
      return createHRAddonConfig(rogue, buyRequest)
    case 'addon-indy':
      return createIndyAddonConfig(rogue, buyRequest)
    case 'addon-lrlp':
      return createLatLowRowAddonConfig(rogue, buyRequest)
    case 'addon':
      return createStandardAddonConfig(rogue, buyRequest)
    case 'standard-6':
    default:
      return createStandardConfig(rogue, buyRequest)
  }
}

export function createFunctionalTrainer(rogue: IRogue, buyRequest: BuyRequest) {
  const config: RackOptions = createFunctionalTrainerConfig(rogue, buyRequest)
  const part = FunctionalTrainerFactory.build(config)
  
  return { config, part }
}